import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/Home';
import CorporateGifting from './pages/CorporateGifting';
import PersonalisedGifting from './pages/PersonalisedGifting';
import CategoryDetail from './pages/CategoryDetail';
import Diwali from './pages/Diwali';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import SeoLandingPage from './pages/SeoLandingPage';
import CaseStudyDetail from './pages/CaseStudyDetail';
import CaseStudiesIndex from './pages/CaseStudiesIndex';
import { Toaster } from './components/ui/toaster';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

function Chrome({ children, hideChrome }) {
  return (
    <>
      {!hideChrome && <Header />}
      {children}
      {!hideChrome && <Footer />}
      {!hideChrome && <WhatsAppFloat />}
    </>
  );
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <Chrome hideChrome={isAdmin}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/corporate-gifting" element={<CorporateGifting />} />
        <Route path="/personalised-gifting" element={<PersonalisedGifting />} />
        <Route path="/diwali" element={<Diwali />} />

        {/* High-Intent SEO Silo Landing Pages */}
        <Route path="/employee-welcome-kits" element={<SeoLandingPage pageSlug="employee-welcome-kits" />} />
        <Route path="/client-gifting" element={<SeoLandingPage pageSlug="client-gifting" />} />
        <Route path="/festive-hampers" element={<SeoLandingPage pageSlug="festive-hampers" />} />
        <Route path="/wedding-return-gifts" element={<SeoLandingPage pageSlug="wedding-return-gifts" />} />
        <Route path="/occasion-gifting" element={<SeoLandingPage pageSlug="occasion-gifting" />} />
        <Route path="/corporate-gifting-delhi-ncr" element={<SeoLandingPage pageSlug="corporate-gifting-delhi-ncr" />} />
        <Route path="/corporate-gifting-gurgaon" element={<SeoLandingPage pageSlug="corporate-gifting-gurgaon" />} />
        <Route path="/corporate-gifts-bangalore" element={<SeoLandingPage pageSlug="corporate-gifts-bangalore" />} />

        {/* Case Studies & Client Stories */}
        <Route path="/case-studies" element={<CaseStudiesIndex />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="/client-stories" element={<CaseStudiesIndex />} />
        <Route path="/client-stories/:slug" element={<CaseStudyDetail />} />
        <Route path="/delivering-custom-diwali-hampers-delhi" element={<CaseStudyDetail forcedSlug="delivering-custom-diwali-hampers-delhi" />} />
        <Route path="/year-round-gifting-remote-first-startup" element={<CaseStudyDetail forcedSlug="year-round-gifting-remote-first-startup" />} />
        <Route path="/client-retention-corporate-gifting-ca-firm" element={<CaseStudyDetail forcedSlug="client-retention-corporate-gifting-ca-firm" />} />

        <Route path="/category/:type/:id" element={<CategoryDetail />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Chrome>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
